<template>
<!-- eslint-disable -->
  <div class="cookies">
    <img class="cookies__logo" src="@/assets/images/brand/logo_login.svg" alt="Early Stage" />
    <div class="cookies__content">
      <div class="cookies__content__title">
        Cookies
      </div>
      <div class="cookies__content__text">
         <p>
        <span class="font-bold">IV.1.</span> Pliki cookies (tzw. ciasteczka) stanowią dane informatyczne, w szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu – np. poprzez zapamiętywanie odwiedzin Użytkownika w Serwisie i dokonywanych przez niego czynności. Pliki Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer. Pliki Cookies zbierają informacje ułatwiające korzystanie ze strony internetowej.
      </p>
      <p>Pliki cookies wykorzystywane są w Serwisie w celu:</p>
      <div>
        <p>
          <span class="font-bold">a)</span> dostosowania zawartości stron internetowych Serwisu do preferencji Użytkownika oraz optymalizacji korzystania przez Użytkownika z Serwisu; w szczególności pliki te pozwalają rozpoznać urządzenie Użytkownika Serwisu i odpowiednio wyświetlić stronę internetową, dostosowaną do jego indywidualnych potrzeb;
        </p>
        <p>
          <span class="font-bold">b)</span> tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron internetowych, co umożliwia ulepszanie ich struktury i zawartości;
        </p>
        <p>
          <span class="font-bold">c)</span> utrzymania sesji Użytkownika Serwisu (po zalogowaniu do Profilu), dzięki której Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;
        </p>
      </div>
      <p>
        <span class="font-bold">IV.2.</span> W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: sesyjne (session cookies) oraz stałe (persistent cookies). Pliki cookies sesyjne są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania (przeglądarki internetowej). Stałe pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.
      </p>
      <p>Administrator wykorzystuje następujące pliki Cookies:</p>
      <div>
        <p>
          <span class="font-bold">a)</span> ”niezbędne” pliki cookies, umożliwiające korzystanie z usług dostępnych w ramach Serwisu, np. uwierzytelniające pliki cookies wykorzystywane do usług wymagających uwierzytelniania w ramach Serwisu;
        </p>
        <p>
          <span class="font-bold">b)</span> pliki cookies służące do zapewnienia bezpieczeństwa, np. wykorzystywane do wykrywania nadużyć w zakresie uwierzytelniania w ramach Serwisu;
        </p>
        <p>
          <span class="font-bold">c)</span> ”wydajnościowe” pliki cookies, umożliwiające zbieranie informacji o sposobie korzystania ze stron internetowych Serwisu;
        </p>
        <p>
          <span class="font-bold">d)</span> ”funkcjonalne” pliki cookies, umożliwiające ”zapamiętanie” wybranych przez Użytkownika ustawień i personalizację interfejsu Użytkownika, np. w zakresie wybranego języka lub regionu, z którego pochodzi Użytkownik, rozmiaru czcionki, wyglądu strony internetowej itp.;
        </p>
        <p>
          <span class="font-bold">e)</span> ”reklamowe” pliki cookies, umożliwiające dostarczanie Użytkownikom treści reklamowych bardziej dostosowanych do ich zainteresowań;
        </p>
      </div>
      <p>
        <span class="font-bold">IV.3.</span> Wykorzystanie plików cookies w celu zbierania za ich pośrednictwem danych, w tym uzyskania dostępu do danych zapisanych na urządzeniu Użytkownika, wymaga uzyskania zgody Użytkownika. Zgoda ta może być w każdym momencie wycofana. Zgoda nie jest wymagane jedynie w przypadku plików cookies, których stosowanie jest niezbędne do świadczenia usługi telekomunikacyjnej (transmisja danych w celu wyświetlenia treści).
      </p>
      <p>W wielu przypadkach oprogramowanie służące do przeglądania stron internetowych (przeglądarka internetowa) domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać w każdym czasie zmiany ustawień dotyczących plików cookies lub wycofać swoja zgodę w tym zakresie. Ustawienia te mogą zostać zmienione w szczególności w taki sposób, aby blokować automatyczną obsługę plików cookies w ustawieniach przeglądarki internetowej bądź informować o ich każdorazowym zamieszczeniu w urządzeniu Użytkownika Serwisu. Szczegółowe informacje o możliwości i sposobach obsługi plików cookies dostępne są w ustawieniach oprogramowania (przeglądarki internetowej):</p>
      <div>
        <p>
          <span class="font-bold">a) </span>
          <a
            href="https://support.microsoft.com/pl-pl/help/17442/windows-internetexplorer-delete-manage-cookies"
          >Internet Explorer</a>
        </p>
        <p>
          <span class="font-bold">b) </span>
          <a
            href="http://support.mozilla.org/pl/kb/ciasteczka"
          >Mozilla Firefox</a>
        </p>
        <p>
          <span class="font-bold">c) </span>
          <a
            href="http://support.google.com/chrome/bin/answer.py?hl=pl&answer=95647"
          >Google Chrome</a>
        </p>
        <p>
          <span class="font-bold">d) </span>
          <a
            href="http://help.opera.com/Windows/12.10/pl/cookies.html"
          >Opera</a>
        </p>
        <p>
          <span class="font-bold">e) </span>
          <a
            href="https://support.apple.com/kb/PH5042?locale=en-GB"
          >Safari</a>
        </p>
      </div>
      <p>Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu.</p>
      <p>Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu wykorzystywane mogą być również przez współpracujących z Administratorem reklamodawców oraz partnerów.</p>
      </div>
      <div class="cookies__content__buttons">
        <button @click="$router.back()">{{ $t('cookies.cancel') }}</button>
        <button
          @click="setCookie"
          class="cookies__content__buttons-accept"
        >
          {{ $t('cookies.accept_cookies') }}
        </button>
      </div>
    </div>
    <div class="kid_first-wrapper">
      <img class="kid_first-desktop" src="@/assets/images/welcome/kid_first-desktop.svg" />
    </div>
    <div class="kid_second-wrapper">
      <img class="kid_second-desktop" src="@/assets/images/welcome/kid_second-desktop.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiesNotification',
  data() {
    return {
      isCookie: false,
    };
  },
  methods: {
    setCookie() {
      this.$cookies.set('user_session', '25j_7Sl6xDq2Kc3ym0fmrSSk2xV2XkUk2');
      this.isCookie = true;
      this.$router.back();
    },
  },
  created() {
    if (this.$cookies.get('user_session')) {
      this.isCookie = true;
    }
  },
};
</script>

<style lang="scss" scoped>

.cookies {
  @apply relative flex flex-col items-center mx-auto my-0 text-center;
  min-height: 100vh;
  overflow: hidden;
  max-width: 600px;
  @media screen and (min-width: 768px) {
    max-width: 1600px;
  }
  &__logo {
    @apply h-auto block mx-auto;
    max-width: 200px;
    margin-top: 30px;
    @media screen and (min-width: 768px) {
      max-width: 220px;
    }
    @media screen and (min-width: 1600px) {
      max-width: 335px;
      margin-top: 50px;
    }
  }
  &__content {
    @apply mx-6;
    background: #fff;
    margin-top: 2rem;
    border-radius: 1rem;
    max-width: 900px;
    padding: 2rem 1rem 1rem;
    @media screen and (min-width: 768px) {
        padding: 2rem 2rem 1rem;
        margin-top: 3rem;
      }
    &__title {
      @apply text-center font-bold text-2xl block my-3 px-3 pb-2;
      @media screen and (min-width: 768px) {
        @apply text-3xl pb-0;
      }
      @media screen and (min-width: 1600px) {
        @apply text-4xl pb-8;
      }
    }
    &__text {
      @apply leading-normal text-base px-2 mb-3;
      height: 40vh;
      overflow-y: scroll;
      @media screen and (min-width: 370px) {
        height: 48vh;
      }
      @media screen and (min-width: 768px) {
        @apply text-lg px-8;
      }
      @media screen and (min-width: 768px) {
        @apply text-xl;
      }
      h4 {
        @apply font-bold py-5;
      }
      p {
        @apply text-left py-4;
      }
    }
    &__buttons {
      @apply flex flex-col-reverse justify-between py-3 px-0;
      @media screen and (min-width: 500px) {
        @apply flex-row px-6;
      }
      &-accept {
        @apply mb-3;
        border: 1px solid #000;
        border-radius: 2rem;
        padding: 0.6rem 1.2rem;
        font-weight: 600;
        @media screen and (min-width: 500px) {
          @apply mb-0;
        }
      }
    }
  }

  .kid_first-wrapper {
    left: 30px;
    animation: fadeLeft 1s ease-in-out 0.1s forwards,
      fadeIn 0.5s ease-in-out 0.8s forwards;
  }

  .kid_second-wrapper {
    right: 0;
    animation: fadeRight 1s ease-in-out 0.1s forwards,
      fadeIn 0.5s ease-in-out 0.8s forwards;
  }
}

.kid_first-wrapper,
.kid_second-wrapper {
  @apply absolute opacity-0;
  bottom: 40px;
  .kid_first-desktop {
    display: none;
    @media screen and (min-width: 1350px) {
      display: block;
      width: 140px;
    }
    @media screen and (min-width: 1600px) {
      width: 180px;
    }
  }
  .kid_second-desktop {
    display: none;
    @media screen and (min-width: 1350px) {
      display: block;
      width: 210px;
    }
    @media screen and (min-width: 1600px) {
      width: 250px;
    }
  }
}
</style>
